export default "__VITE_ASSET__Btucz3u8__"